import styled from 'styled-components'
import { InfoIcon } from 'components/sto/Section/Section.styles'
import { stoColor, stoSpace, stoType } from 'constants/stoTheme'

export const Groups = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const Group = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${stoSpace[5]};

  & + & {
    margin-top: ${stoSpace[5]};
    padding-top: ${stoSpace[8]};
    border-top: 1px solid ${stoColor.borderSubtle};
  }
`

/** A <p>, as in Figma: the global h3 rule forces 22px with !important. */
export const GroupTitle = styled.p`
  ${stoType.columnLabel};
  margin: 0;
  color: ${stoColor.textSecondary};
`

export const Row = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${stoSpace[4]};
  width: 100%;
`

export const ValueGroup = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
`

export const Label = styled.span`
  ${stoType.bodyMdRegular};
  color: ${stoColor.textTertiary};
  flex-shrink: 0;
`

export const Value = styled.span`
  ${stoType.bodyMdCallout};
  min-width: 0;
  color: ${stoColor.textPrimary};
  text-align: right;
  overflow-wrap: anywhere;
`

export const ValueLink = styled.a`
  ${stoType.bodyMdCallout};
  display: inline-flex;
  align-items: center;
  gap: ${stoSpace[1]};
  min-width: 0;
  color: ${stoColor.textPrimary} !important;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }

  svg {
    flex: 0 0 auto;
  }
`

export const LinkText = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

/** The page's tooltip icon (Section's InfoIcon), a size up and black like the external link icon. */
export const TooltipIcon = styled(InfoIcon)`
  font-size: 18px;
  color: ${stoColor.textPrimary};
`
